<template>
    <div>
        <main>
            <CxPortfolio />
        </main>
    </div>
</template>

<script>
import CxPortfolio from '@/components/CxPortfolio.vue'

export default {
    components: {
        CxPortfolio
    }}
</script>